import React from 'react';
import { Link } from 'react-router-dom';

const ThankYou = () => (
  <div className="max-w-xl mx-auto py-20 text-center">
    <h1 className="text-3xl font-bold mb-4">Thank you!</h1>
    <p className="mb-6">Your information has been received. Our team will review your case and contact you shortly.</p>
    <Link to="/" className="btn-primary">Back to Home</Link>
  </div>
);

export default ThankYou; 